import type { EngineeringProduct } from './types'

const UZBEK_SEASON_NAMES: Record<string, string> = {
  winter: 'Qish',
  qish: 'Qish',
  summer: 'Yoz',
  yoz: 'Yoz',
  spring: 'Bahor',
  bahor: 'Bahor',
  autumn: 'Kuz',
  fall: 'Kuz',
  kuz: 'Kuz',
  all_season: 'Barcha mavsum',
  all_seasons: 'Barcha mavsum',
  spring_summer: 'Bahor / Yoz',
  autumn_winter: 'Kuz / Qish',
  fall_winter: 'Kuz / Qish',
}

function normalizeSeason(value?: string | null): string {
  return (value ?? '')
    .trim()
    .toLocaleLowerCase()
    .replace(/&/g, ' and ')
    .replace(/\band\b/g, ' ')
    .replace(/[^a-z0-9Ѐ-ӿʻ‘’]+/g, '_')
    .replace(/^_+|_+$/g, '')
}

/**
 * Uzbek name of one season code/label (`spring_summer` → `Bahor / Yoz`).
 * Unknown values are returned unchanged so a custom season is never hidden.
 */
export function uzbekSeasonName(value?: string | null): string {
  const raw = value?.trim() ?? ''
  if (!raw) return ''
  return UZBEK_SEASON_NAMES[normalizeSeason(raw)] ?? raw
}

export function uzbekProductSeason(product?: EngineeringProduct | null): string {
  if (!product) return ''
  return uzbekSeasonName(product.season_info?.code)
    || uzbekSeasonName(product.season)
    || uzbekSeasonName(product.season_info?.name)
    || product.season_info?.name?.trim()
    || product.season?.trim()
    || ''
}
